import React,{useState,useEffect} from 'react'
import {Link} from 'react-router-dom'
import {Form,Button,Row,Col} from 'react-bootstrap'
import Loader from '../components/Loader'
import Message from '../components/Message'
import FormContainer from '../components/FormContainer'

import {login} from '../actions/userActions'
import {useDispatch,useSelector} from 'react-redux'

// 感覺從App.js 那邊的route 繼承了location,history 透過component
// location 傳遞了現在的url位置
// history 有redirect 的功能
function LoginScreen({location,history}) {
    //console.log(location);
    const [username,setUsername] = useState('')
    const [password,setPassword] = useState('')
    const dispatch = useDispatch()
    
    const redirect = location.search ? location.search.split('=')[1] : 'video'
    const userLogin = useSelector(state=>state.userLogin)
    const {error,loading,userInfo} = userLogin

    useEffect(() => {
        if(userInfo){
            history.push(redirect)
        }

    }, [history,userInfo,redirect])


    const submitHandler = (e) =>{
        e.preventDefault()
        //console.log(username,password)
        dispatch(login(username,password))
    }

    return (
        <FormContainer >
            <h1 style={{color:'gray'}}>旌旗牧養影音</h1>
            {error && <Message variant='danger'>{error}</Message> }
            {loading && <Loader/>}
            <Form onSubmit={submitHandler}>

              <Form.Group controlId="username" style={{marginBottom:"20px"}}>
                <Form.Label style={{WebkitTextStroke: "0.5px",color:'gray'}}>帳號</Form.Label>
                <Form.Control
                    type= "username"
                    placeholder="enter Username"
                    value ={username}
                    onChange={ (e)=>setUsername(e.target.value) }
                >
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="password" style={{marginBottom:"20px"}}>
                <Form.Label style={{WebkitTextStroke: "0.5px" ,color:'gray'}} >密碼</Form.Label>
                <Form.Control
                    type= "password"
                    placeholder="enter password"
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                >
                </Form.Control>
              </Form.Group>

              <Button type="submit" variant="primary" style={{marginBottom:"20px"}}>
                  登入
              </Button>

            </Form>

            <Row className='py-3'>
                <Col>
           
                </Col>
            </Row>


        </FormContainer>
      
        
    )
}

export default LoginScreen
